/**
 * clone of a Theme enum to utilize in auth context.
 * -    since typescript does not allow to extend/clone enums
 *      we have to duplicate the Theme enum here.
 *
 * If you ever add another Theme, please update the values here as well!
 *
 */

export enum SignedInMethod {
  Wine = 'wine',
  Beer = 'beer',
  Ethanol = 'ethanol',
}
